// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"b9e6130a","977":"b6a0dcff"}[chunkId] + ".chunk.js";
};